(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fg-localization"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const configElement = document.getElementById('fg-localization-config');
  if (!configElement || !/^(www\.)?fashiongirl\.eu$/.test(location.hostname) || /^\/[a-z]{2}-ch(?:\/|$)/i.test(location.pathname)) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  const dedicated = new Set(['AT', 'CH', 'DE', 'FR', 'IE', 'NL', 'SE']);
  const manualKey = 'fg-country-choice-v1';
  const detectionKey = 'fg-country-detection-v1';
  const attemptKey = 'fg-country-attempt-v1';
  let destination = '';
  let choiceChanged = false;
  let scheduled = false;

  function supported(code) {
    return typeof code === 'string' && /^[A-Z]{2}$/.test(code) && Object.prototype.hasOwnProperty.call(config.countries, code);
  }

  function eligible(code) {
    return supported(code) && !dedicated.has(code);
  }

  function read(storageName, key, maxAge) {
    try {
      const value = JSON.parse(window[storageName].getItem(key));
      const age = Date.now() - value.at;
      return supported(value.code) && age >= 0 && age < maxAge ? value.code : '';
    } catch (_) { return ''; }
  }

  function write(storageName, key, code) {
    try {
      window[storageName].setItem(key, JSON.stringify({code, at: Date.now()}));
      return true;
    } catch (_) { return false; }
  }

  function render() {
    scheduled = false;
    const suffix = destination ? ' ' + config.destination.replace('__COUNTRY__', config.countries[destination]) : '';
    document.querySelectorAll('[data-fg-delivery-base]').forEach(element => {
      const base = element.getAttribute('data-fg-delivery-base');
      const previous = element.getAttribute('data-fg-delivery-rendered') || base;
      const next = base + suffix;
      const current = element.textContent.trim();
      if ((current === base || current === previous) && current !== next) element.textContent = next;
      element.setAttribute('data-fg-delivery-rendered', next);
    });
    document.querySelectorAll('[data-fg-country-suffix]').forEach(element => {
      if (element.textContent !== suffix) element.textContent = suffix;
    });
  }

  function scheduleRender() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(render);
    }
  }

  function rememberChoice(code) {
    if (!supported(code)) return;
    choiceChanged = true;
    write('localStorage', manualKey, code);
    destination = code === config.country && eligible(code) ? code : '';
    render();
  }

  document.addEventListener('click', event => {
    const option = event.target.closest('[data-disclosure-currency] [data-disclosure-option]');
    if (option) rememberChoice(option.getAttribute('data-value'));
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('select[name="country_code"]')) rememberChoice(event.target.value);
  }, true);
  document.addEventListener('submit', event => {
    const input = event.target.querySelector('[name="country_code"]');
    if (input && event.target.id !== 'fg-automatic-localization') rememberChoice(input.value);
  }, true);
  new MutationObserver(scheduleRender).observe(document.body, {childList: true, subtree: true});

  function selectCountry(code) {
    if (!eligible(code) || choiceChanged) return;
    if (code === config.country) {
      destination = code;
      render();
      return;
    }
    if (read('sessionStorage', attemptKey, 30 * 60 * 1000)) return;
    if (!write('sessionStorage', attemptKey, code)) return;
    const form = document.createElement('form');
    form.id = 'fg-automatic-localization';
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    const returnUrl = new URL(location.href);
    returnUrl.searchParams.delete('country');
    const fields = {
      form_type: 'localization',
      _method: 'put',
      country_code: code,
      return_to: returnUrl.pathname + returnUrl.search + returnUrl.hash
    };
    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  const queryCountry = new URLSearchParams(location.search).get('country');
  if (supported(queryCountry)) {
    write('localStorage', manualKey, queryCountry);
    selectCountry(queryCountry);
    return;
  }
  const manual = read('localStorage', manualKey, 180 * 24 * 60 * 60 * 1000);
  if (manual) {
    selectCountry(manual);
    return;
  }
  const cached = read('sessionStorage', detectionKey, 30 * 60 * 1000);
  if (cached) {
    selectCountry(cached);
    return;
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const root = config.root.replace(/\/?$/, '/');
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(config.country) + '&language[enabled]=false', {
    credentials: 'same-origin',
    headers: {Accept: 'application/json'},
    signal: controller.signal
  }).then(response => {
    if (!response.ok) throw new Error('Country detection unavailable');
    return response.json();
  }).then(data => {
    const code = data.detected_values?.country?.handle;
    if (!eligible(code) || choiceChanged) return;
    const suggestion = data.suggestions?.find(item => item.parts?.country)?.parts.country;
    if (suggestion && (suggestion.handle !== code || !(suggestion.confidence >= 0.9))) return;
    write('sessionStorage', detectionKey, code);
    selectCountry(code);
  }).catch(() => {}).finally(() => clearTimeout(timeout));
})();
  } catch(e) { console.error(e); }
})();

})();
